exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-page__head[data-v-e5d84188]{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px 16px;margin-bottom:12px}.pi-page__head .pi-page__title[data-v-e5d84188]{margin:0}.pi-eng__as-of[data-v-e5d84188]{margin-bottom:8px}.pi-eng__subhead[data-v-e5d84188]{display:flex;flex-wrap:wrap;align-items:center;gap:6px 8px;margin:12px 0 8px}.pi-eng__subtitle[data-v-e5d84188]{margin:0}.pi-eng__dimension[data-v-e5d84188]{display:inline-flex;align-items:center;gap:6px}.pi-eng__drop[data-v-e5d84188]{display:inline-flex;align-items:center;gap:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e5d84188","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/restricted/productIntelligence/piEngagement.vue
// module id = 1645
// module chunks = 0